import { render, staticRenderFns } from "./import-createtaskpersonnel-form.vue?vue&type=template&id=59587888&scoped=true&"
import script from "./import-createtaskpersonnel-form.vue?vue&type=script&lang=js&"
export * from "./import-createtaskpersonnel-form.vue?vue&type=script&lang=js&"
import style0 from "./import-createtaskpersonnel-form.vue?vue&type=style&index=0&id=59587888&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59587888",
  null
  
)

export default component.exports